import React, { useEffect, useState } from 'react';
import styles from './HeroCarousel.module.scss';
import { Image } from '../../../components/Image/Image';

type Slide = {
  image: { mobile: string; desktop: string };
  alt: string;
  caption: string;
  subcaption: string;
};

const AUTO_ADVANCE_MS = 6000;

export const HeroCarousel = (props: { slides: Slide[] }): React.JSX.Element => {
  const { slides } = props;
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (slides.length < 2) return;
    const timer = setInterval(() => {
      setActive((current) => (current + 1) % slides.length);
    }, AUTO_ADVANCE_MS);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className={styles.carousel}>
      <div className={styles.frame}>
        {slides.map((slide, i) => (
          <div key={slide.caption} className={styles.slide} data-active={i === active}>
            <Image
              sources={[
                { src: slide.image.mobile, breakpoint: 'default' },
                { src: slide.image.desktop, breakpoint: '720px' },
              ]}
              alt={slide.alt}
            />
            <div className={styles.overlay}>
              <p className={styles.caption}>{slide.caption}</p>
              <p className={styles.subcaption}>{slide.subcaption}</p>
            </div>
          </div>
        ))}
        {slides.length > 1 && (
          <div className={styles.dots}>
            {slides.map((slide, i) => (
              <button
                key={slide.caption}
                aria-label={`Show slide ${i + 1}`}
                data-active={i === active}
                onClick={() => setActive(i)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
